import { Component, inject } from '@angular/core';
import { environments } from '@core/constants/environments';
import { repositories } from '@core/constants/repositories';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
})
export class SidenavComponent {
  auth = inject(AuthService);
  showNav = true;

  environments = environments;
  repositories = repositories;

  ngOnInit() {
  }
}
